import {TEAMS} from "config/names";

export const variantToColor = {
  [TEAMS.ATMOS]: "#6ED1EC",
  [TEAMS.CAPRA]: "#009918",
  [TEAMS.MAVRIC]: "#FF7942"
}